module.exports = __webpack_public_path__ + "static/3dmss_logo_home-d56dc28d28a4e8c8a9031381f48c3828.svg";